import { STORAGE_KEYS } from '@/config/constants'
import { User } from '@/types'

export const storage = {
  get: <T>(key: string): T | null => {
    try {
      const item = localStorage.getItem(key)
      return item ? (JSON.parse(item) as T) : null
    } catch {
      return null
    }
  },

  set: <T>(key: string, value: T): void => {
    try {
      localStorage.setItem(key, JSON.stringify(value))
    } catch (error) {
      console.error('Error saving to localStorage:', error)
    }
  },

  remove: (key: string): void => {
    try {
      localStorage.removeItem(key)
    } catch (error) {
      console.error('Error removing from localStorage:', error)
    }
  },

  clear: (): void => {
    try {
      localStorage.clear()
    } catch (error) {
      console.error('Error clearing localStorage:', error)
    }
  },
}

export const authStorage = {
  getToken: (): string | null => {
    return storage.get<string>(STORAGE_KEYS.AUTH_TOKEN)
  },

  setToken: (token: string): void => {
    storage.set(STORAGE_KEYS.AUTH_TOKEN, token)
  },

  removeToken: (): void => {
    storage.remove(STORAGE_KEYS.AUTH_TOKEN)
  },

  getUser: (): User | null => {
    return storage.get<User>(STORAGE_KEYS.USER)
  },

  setUser: (user: User): void => {
    storage.set(STORAGE_KEYS.USER, user)
  },

  removeUser: (): void => {
    storage.remove(STORAGE_KEYS.USER)
  },

  clear: (): void => {
    authStorage.removeToken()
    authStorage.removeUser()
  },
}

